<template>
  <div class="image-album">
    <edit-file class="short align-top" use-case="cover" :name="`img_${index}`" v-if="isLoaded" title="Изображение"/>
    <edit-input title="Описание изображения" :name="`img_desc_${this.index}`"/>
    <div class="buttons">
      <button @click="swap('Up')" v-if="index > 0">Вверх</button>
      <button @click="swap('Down')" v-if="index+1 !== item.object.length">Вниз</button>
      <button @click="deleteItem" v-if="!(item.object.length === 1 && index === 0)">Удалить</button>
    </div>
  </div>
</template>

<script>
  import EditInput from '@/components/edit-form/new-items/Input'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')
  export default {
    name: "ImageAlbum",
    props: ['image', 'imgDesc', 'index'],
    data() {
      return {
        deleteIndex: 0
      }
    },
    computed: {
      ...mapState([
        'isLoaded',
        'errors',
        'item'
      ])
    },
    methods: {
      ...mapMutations([
        'setErrors',
        'setItemField',
        'deleteItemField',
        'setFileExtension'
      ]),
      deleteItem() {
        let object = [];
        for (let i = 0; i < this.item.object.length; i++) {
          object.push({img: this.item[`img_${i}`], img_desc: this.item[`img_desc_${i}`]})
        }
        this.setItemField({fieldName: 'object', value: []});
        object.splice(this.index, 1);
        window.requestAnimationFrame(() => {
          this.setItemField({fieldName: 'object', value: object});
        })
        this.deleteItemField(`img_${this.index}`);
        this.deleteItemField(`img_desc_${this.index}`);
      },
      swap(direction) {
        let object = [];
        for (let i = 0; i < this.item.object.length; i++) {
          object.push({img: this.item[`img_${i}`], img_desc: this.item[`img_desc_${i}`]})
        }
        this.setItemField({fieldName: 'object', value: []});
        if (direction === 'Up') {
          [object[this.index - 1], object[this.index]] = [object[this.index], object[this.index - 1]];
        } else {
          [object[this.index], object[this.index + 1]] = [object[this.index + 1], object[this.index]];
        }
        window.requestAnimationFrame(() => {
          this.setItemField({fieldName: 'object', value: object});
        })


      },
    },
    created() {
      this.deleteIndex = this.index;
      this.setItemField({fieldName: `img_${this.index}`, value: this.image});
      this.setItemField({fieldName: `img_desc_${this.index}`, value: this.imgDesc});
      let errors = JSON.parse(JSON.stringify(this.errors));
      errors[`img_${this.index}`] = {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false};
      errors[`img_desc_${this.index}`] = {message: 'Введите описание изображения', hasError: false};
      this.setErrors(errors);
      this.setFileExtension({name: `img_${this.index}`, value: ['jpg', 'jpeg', 'png', 'gif']})
    },
    components: {
      EditInput,
      EditFile
    }
  }
</script>

<style lang="scss" scoped>
  .buttons {
    display: flex;
    justify-content: flex-end;
    button {
      color: #fff;
      background: #089cd3;
      border-radius: 20px;
      border: 1px solid #089cd3;
      padding: 3px;
      width: 85px;
      margin-right: 5px;
      font-size: 15px;
      transition: .3s;
      &:hover {
        background-color: transparent;
        color: #089cd3;
        cursor: pointer;
        transition: .3s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/ImageAlbum.vue